<template>
  <component :is="template">
    <router-view />
  </component>
  <AlertGeneral />
  <Loading v-if="isLoading" :message="'Cargando'"></Loading>
</template>
<script setup lang="ts">
  import { computed, defineAsyncComponent, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import AlertGeneral from './shared/components/AlertGeneral.vue'
  import Loading from '@/shared/components/Loading.vue'
  import useLoading from './store/load'

  const HomeLayout = defineAsyncComponent(() => import('@/layouts/Home.vue'))

  const route = useRoute()
  const loadingStore = useLoading()
  const isLoading = ref(false)

  loadingStore.$subscribe((mutation, state) => {
    isLoading.value = state.isChargingBatteries
  })

  const template = computed(() => {
    const layout = route.meta.layout || 'public'
    return layout === 'home' ? HomeLayout : layout
  })
</script>

<style scoped></style>
